// skeleton-table.tsx

import { Skeleton, SkeletonProps, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import classNames from 'classnames';

export type SkeletonTableColumnsType = {
  key: string;
};

type ExtendedColumnType = ColumnsType<SkeletonTableColumnsType>[number] & {
  showAvatarSkeleton?: boolean;
  paragraphRows?: number;
  avatarClassName?: string;
  avatarSize?: 'large' | 'small' | 'default' | number;
};

type SkeletonTableProps = SkeletonProps & {
  columns: ExtendedColumnType[];
  rowCount?: number;
};

export default function SkeletonTable({
  loading = false,
  active = false,
  rowCount = 5,
  columns,
  children,
  className,
}: SkeletonTableProps): any {
  return loading ? (
    <Table
      rowKey="key"
      pagination={false}
      dataSource={[...Array(rowCount)].map((_, index) => ({
        key: `key${index}`,
      }))}
      columns={columns.map((column) => {
        return {
          ...column,
          render: function renderPlaceholder() {
            const { key, showAvatarSkeleton, paragraphRows, avatarSize } = column;
            return (
              <Skeleton
                key={key}
                title
                active={active}
                paragraph={paragraphRows ? { rows: paragraphRows } : false}
                className={classNames(className, column.avatarClassName)}
                {...(showAvatarSkeleton && {
                  avatar: { shape: 'circle', size: avatarSize || 'default' },
                })}
                round
              />
            );
          },
        };
      })}
    />
  ) : (
    <>{children}</>
  );
}
